import { render, staticRenderFns } from "./InsinfoaView.vue?vue&type=template&id=5294e516&scoped=true&"
import script from "./InsinfoaView.vue?vue&type=script&lang=js&"
export * from "./InsinfoaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5294e516",
  null
  
)

export default component.exports